module.exports = __webpack_public_path__ + "img/ylc_logo.7ff49b94.png";